<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <div class="lg:max-w-detail lg:mr-auto">
            <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t("companies.configuration.configuracion_certificado") }}</h3>
            <div class="mb-4">
              <el-switch
                class="switch-text break-normal"
                v-model="form.FirmaDelegadaActivo"
                :inactive-text="$t('companies.configuration.certificado_zc')"
                :active-text="$t('companies.configuration.certificado_pfx')"
              />
            </div>
            <div class="rounded-md p-1 dark:text-darkblue-400 dark:bg-darkblue-900">
              <div>
                <template v-if="form.FirmaDelegadaActivo">
                  <div v-if="form.CN && form.FirmaDelegadaActivo" class="flex space-between items-end m-2">
                    <div class="w-full">
                      <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">
                        {{ $t("certificates.entity_name") }}
                      </h2>
                      <div class="px-2 w-full mt-2">
                        <base-ro-input :label="$t('app.name')" :data="form.CN"/>
                      </div>
                    </div>
                    <base-button
                      class="mb-1"
                      mode="primary"
                      :text="$t('app.detail')"
                      @click.prevent.stop="goDetailCert"
                      :loading="isGeneralLoading"
                    />
                  </div>
                  <div v-else>
                    <div class="mb-4">
                      <base-tip-box type="info" :text-content="$t('companies.configuration.certificate')" :links="adviceLinks" />
                    </div>
                    <div class="flex space-between items-center m-2">
                      <div class="flex justify-between w-full">
                        <h2 v-if="false" class="font-bold mb-2">
                          {{$t("companies.configuration.no_associated_cert")}}
                        </h2>
                        <base-ro-input-minimal label="" :data=" $t('companies.configuration.no_associated_cert_advice')"/>
                        <base-button
                          v-if="!isRoleUserOrConsulta"
                          class="mb-1"
                          mode="primary"
                          :text="$t('app.link_entity_existing')"
                          @click.prevent.stop="togglelinkCertificateDialog"
                          :loading="isGeneralLoading"
                          style="margin-right: 10px;"
                        />
                        <base-button
                          v-if="!isRoleUserOrConsulta"
                          class="mb-1"
                          mode="primary"
                          :text= "$t('rules.add_certificate')"
                          @click.prevent.stop="goToCreateCertificate"
                          :loading="isGeneralLoading"
                        />
                      </div>
                    </div>
                  </div>

                </template>
                <template v-else>
                  <div v-if="!this.hasDocumentFirmaDelegada">
                    <el-form :model="responsableForm" :rules="rulesPersonaResponsable" ref="ruleFormResponsable">
                      <div class="mb-4">
                        <base-tip-box type="info" :text-content="$t('companies.configuration.firma_delegada.electronic_signature')" :links="adviceLinks" />
                      </div>
                      <div class="flex">
                        <h2 class="px-2 mb-2 lg:mb-0 font-bold">{{ $t('companies.configuration.firma_delegada.datos_representante') }}</h2>
                        <base-tooltip-icon
                          size="sm"
                          content="Debido a que se quiere firmar con el certificado de Zerocoma, se tienen que rellenar los datos de representante"
                          class="ml-1"
                        />
                      </div>
                      <div class="w-full m-2 flex items-center">
                        <el-form-item prop="NombreApellidos" class="mt-2 mr-1 w-full">
                          <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ContactPersons_short') }}</label>
                          <el-input v-model="responsableForm.NombreApellidos"/>
                        </el-form-item>
                        <el-form-item prop="NIF" class="mt-2 ml-1 w-full">
                          <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.nif_nie') }}</label>
                          <el-input v-model="responsableForm.NIF" />
                        </el-form-item>
                      </div>
                      <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">{{ $t('companies.configuration.firma_delegada.domicilio_fiscal') }}</h2>
                      <div class="w-full m-2">
                        <div class="mt-2 w-full">
                          <el-form-item prop="Municipio">
                            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration.firma_delegada.municipio') }}</label>
                            <el-input v-model="responsableForm.Municipio" />
                          </el-form-item>
                          <div class="flex">
                            <el-form-item prop="ViaPublica" class="w-full mr-1">
                              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration.firma_delegada.via_publica') }}</label>
                              <el-input v-model="responsableForm.ViaPublica"/>
                            </el-form-item>
                            <el-form-item prop="NumeroViaPublica" class="w-full ml-1">
                              <label class="text-sm font-semibold text-secondary-600 block mb-1" >{{$t('companies.configuration.firma_delegada.numero')  }}</label>
                              <el-input v-model="responsableForm.NumeroViaPublica"/>
                            </el-form-item>
                          </div>
                          <div class="flex flex-row gap-4 w-full mt-4">
                            <div class="flex justify-around">
                              <base-button
                                :loading="isGeneralLoading"
                                @click.prevent.stop="changeDialogFirmaDelegada(false)">
                                {{ $t('companies.configuration.firma_delegada.ver_pdf_delegacion_firma') }}
                              </base-button>
                            </div>
                            <div class="flex justify-around">
                              <base-button
                                :loading="isGeneralLoading"
                                @click.prevent.stop="uploadDialogFirmaDelegada">
                                {{ $t('companies.configuration.firma_delegada.subir_pdf_firma') }}
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form>
                  </div>
                  <div v-else >
                    <base-button
                      :loading="isGeneralLoading"
                      @click.prevent.stop="changeDialogFirmaDelegada(true)"
                      >{{$t('companies.configuration.firma_delegada.pdf_delegacion_firma_firmado')}}</base-button
                    >
                  </div>
                </template>
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t("companies.configuration.config_firma") }}</h3>
                <div class="mb-4" v-if="!form.FirmarFacturae">
                  <el-switch 
                    class="switch-text break-normal" 
                    v-model="form.FirmarFacturae" 
                    :active-text="$t('companies.configuration.config_firma_facturae')"/>
                </div>
                <div class="mb-4">
                  <el-switch
                    class="switch-text break-normal"
                    v-model="form.FirmarAdjuntos"
                    :active-text="$t('companies.configuration.config_firma_adjuntos')"
                  ></el-switch>
                </div>
              </div>
            </div>

            <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('companies.configuration.configuracion_factura_electronica') }}</h3>

            <div class="lg:mb-2">
              <div class="mandatory pt-2">
                <base-collapsible-form
                  ref="baseCollapsibleGeneral"
                  class="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
                  <template slot="headerRight">
                    <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">
                    {{ $t("companies.configuration.pge_header") }}
                    </h3>
                  </template>
                  <template slot="content">
                    <base-collapsible-form
                      ref="baseCollapsibleFace"
                      class="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
                      <template slot="headerRight">
                        <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">
                          {{ $t("companies.configuration.status_change_email") }}
                          <base-tooltip-icon
                            size="sm"
                            :content="extensionTooltipMessage"
                            class="ml-2"
                            style="display: inline"
                          />
                        </h3>
                      </template>
                      <template slot="content">
                        <!-- <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.configuration.status_change_email')}}</label> -->
                        <el-form-item prop="FaceMailInvoice">
                          <el-input
                            :disabled="isRoleUserOrConsulta"
                            clearable
                            class="w-full"
                            v-model="form.FaceMailInvoice"
                            :maxlength="maxLengthCorreos"
                          />
                        </el-form-item>

                        <div class="mb-4">
                          <el-switch
                            class="switch-text break-normal"
                            v-model="form.FaceRecoverMail"
                            :active-text="
                              $t('companies.configuration.facturae_recover_mail')
                            "
                          ></el-switch>
                        </div>
                      </template>
                    </base-collapsible-form>

                    <base-collapsible-form
                      ref="baseCollapsibleTuComunidad"
                      class="mt-2 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2"
                    >
                      <template slot="headerRight">
                        <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">
                          {{ $t("tipos.pge.tucomunidad") }}
                        </h3>
                      </template>
                      <template slot="content">
                        <label
                          class="text-sm font-semibold text-secondary-600 block mb-1"
                          >{{ $t("users.entity_name") }}</label
                        >
                        <el-form-item prop="TuComunidadUsuario">
                          <el-input
                            :disabled="isRoleUserOrConsulta"
                            clearable
                            class="w-full"
                            v-model="form.TuComunidadUsuario"
                            maxlength="50"
                          />
                        </el-form-item>

                        <div>
                          <label class="text-sm font-semibold text-secondary-600 block mb-1" >{{ $t("users.password") }}</label>
                          <el-form-item prop="TuComunidadPassword">
                            <el-input
                              :disabled="isRoleUserOrConsulta"
                              clearable
                              show-password
                              class="w-full"
                              v-model="form.TuComunidadPassword"
                              autocomplete="new-password"
                              maxlength="50"
                            />
                          </el-form-item>
                          <!-- <el-popover
                          ref="popovertc"
                          placement="top-start"
                          :title="$t('validation.popup.title')"
                          width="320"
                          trigger="focus"
                          popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                          >
                          <div>
                            <div><base-icon-pass-validation :validated="validationtc.numChar"/>{{$t('validation.popup.num_char')}}</div>
                            <div><base-icon-pass-validation :validated="validationtc.numMin"/>{{$t('validation.popup.num_min')}}</div>
                            <div><base-icon-pass-validation :validated="validationtc.charMinus"/>{{$t('validation.popup.char_minus')}}</div>
                            <div><base-icon-pass-validation :validated="validationtc.charMayus"/>{{$t('validation.popup.char_mayus')}}</div>
                            <div><base-icon-pass-validation :validated="validation.especial"/>{{$t('validation.popup.especial')}}</div>
                          </div>
                        </el-popover> -->
                        </div>
                      </template>
                    </base-collapsible-form>
                  </template>
                </base-collapsible-form>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="isCompanyCreation && getModulesClient.length ? $t('app.save_and_continue') : $t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <PDFViewerDialog
        :dialogOpen="firmaDelegadaDialog"
        :blobUrl="pdfVisualicer"
        :idCifEmpresa="id"
        @toggleDialog="closeDialogFirmaDelegada"
        @applyDialog="applyFirmaDelegada"
        :uploadFirmaDelegada="uploadState"
        :isSigned="isSigned"
        :FirmaDelegada="this.form.FirmaDelegadaActivo"
      />
      <link-certificate-dialog
        :dialogOpen="linkCertificateDialog"
        @toggleDialog="togglelinkCertificateDialog"
        @applyDialog="applylinkCertificateDialog"
        :clientId="this.form.clienteId"
      />
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import LinkCertificateDialog from '@/components/LinkCertificateDialog.vue'
import PDFViewerDialog from '@/components/pdf/PDFViewerDialog.vue'

import { getModulosCliente } from '@/services/companies/getModulosCliente'
import { getCompany } from '@/services/companies/getCompany'
import { getConfigCompany } from '@/services/companies/getConfigCompany'
import { linkCertificate } from '@/services/certificates/linkCertificate'
import { updateConfigCompany } from '@/services/companies/updateConfigCompany'
import { getPdfFirmaDelegada } from '@/services/companies/getPDFFirmaDelegada'
import { getPDFFirmaDelegadaFirmada } from '@/services/companies/getPDFFirmaDelegadaFirmada'

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

// import moment from 'moment'
import { email as emailRegex } from '@/utils/regex'
import { i18n } from '@/i18n'

function isValidEmail (value) {
  // Un solo email
  return emailRegex.test(value)
  // Varios emails
  // return value.split(';').every(item => emailRegex.test(item))
}

export default {
  /* eslint-disable camelcase */
  name: 'config-detail',
  components: {
    DetailLayoutFullWidth,
    LinkCertificateDialog,
    PDFViewerDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('companies.configuration.header'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail',
      },
      linkCertificateDialog: false,
      maxLengthCorreos: 500,
      idCliente: null,
      isSigned: false,
      form: {
        CN: null,
        clienteId: null,
        SerialNumber: null,
        TipoCertificado: null,

        FaceMailInvoice: '',
        FaceRecoverMail: false,
        TuComunidadUsuario: '',
        TuComunidadPassword: '',
        FirmarFacturae: true,
        FirmarAdjuntos: false,
        FirmaDelegadaActivo: false,
      },
      responsableForm: {
        NombreApellidos: '',
        NIF: '',
        Municipio: '',
        ViaPublica: '',
        NumeroViaPublica: '',
      },
      validationgv: {
        general: false,
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
      },
      validationtc: {
        general: false,
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
      },
      pdfData: null,
      pdfVisualicer: null,
      firmaDelegadaDialog: false,
      afirma: {
        algorith: 'SHA512withRSA',
        format: 'Adobe PDF',
        params: '',
      },
      cargando: false,
      idCifEmpresa: 0,
      uploadState: false,
      hasDocumentFirmaDelegada: false,
      adviceLinks: {
        findCert: {
          text: i18n.t('app.here'), 
          url: 'https://www.zerocoma.com/wp-content/uploads/2020/07/Guia-para-encontrar-tu-certificado.pdf' 
        },
        faqFNMT: {
          text: i18n.t('app.link'), 
          url: 'https://www.sede.fnmt.gob.es/preguntas-frecuentes/exp-imp-y-elim-de-certificados' 
        },
        downloadAutoFirma: {
          text: i18n.t('app.here'), 
          url: 'https://firmaelectronica.gob.es/ciudadanos/descargas' 
        }
      }
    }
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isCompanyCreation: function () {
      return !!this.$store.getters['app/isInMode'](3)
    },
    getModulesClient: function () {
      return this.$store.getters['app/getModulesClient']
    },
    rules () {
      return {
        FaceMailInvoice: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
          { required: true, validator: this.isEmailValid, trigger: 'blur' },
        ],
        TuComunidadUsuario: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
          { validator: this.validateTuComunidadUser, trigger: 'blur' },
        ],
        TuComunidadPassword: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
          { validator: this.validateTuComunidadPassword, trigger: 'blur' },
        ],
      }
    },
    rulesPersonaResponsable () {
      return {
        NombreApellidos: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        NIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        Municipio: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        ViaPublica: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
        NumeroViaPublica: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
        ],
      }
    },
    extensionTooltipMessage: function () {
      var pges = ['FACe', 'Biscaytik', 'Vizcaya', 'Alava', 'Guipuzcua']
      return this.$t('tooltip.status_change_email_advice', {
        pges: this.listToCommaString(pges, true),
      })
    },
  },
  watch: {
    // form: {
    //   deep: true,
    //   immediate: true,
    //   handler: 'watchFormHandler'
    // }
  },
  created: async function () {
    const companyId = this.$route.params.id
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored })
    } else {
      const company = await this.downloadCompanyData(companyId)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    
    const config = await this.downloadDataConfig(companyId)
    this.setConfig(config)

    if (this.isCompanyCreation) {
      const params = {
        idCliente: this.idCliente, 
      }
      const payload = [
        1, // OCR
        8, // TBAI
        31, // Verifactu
        12, // Recepcion
      ]
      const response = await getModulosCliente(payload, params)
      if (response.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        this.$store.commit('app/setModulesClient', response.Respueta)
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    // this.$refs.baseCollapsibleGeneral.toggle()
    // this.$refs.baseCollapsibleFace.toggle()
    // this.$refs.baseCollapsibleGobiernoVasco.toggle()
    // this.$refs.baseCollapsibleTuComunidad.toggle()
  },
  
  methods: {
    goToCreateCertificate () {
      setTransitionAllowed(3, true)
      this.$store.commit('app/setFormChanges', false)
      this.$router.push({
        name: 'certificates/detail',
        params: {
          idCliente: this.idCliente,
          serial: -1,
          tipoCertificado: -1,
          idCifEmpresa: parseInt(this.$route.params.id)
        },
      })
    },
    togglelinkCertificateDialog () {
      this.linkCertificateDialog = !this.linkCertificateDialog
    },
    changeDialogFirmaDelegada: async function (sign = false) {
      this.isSigned = sign
      this.uploadState = false
      this.$store.commit('setIsLoading', true)
      if (!this.hasDocumentFirmaDelegada) {
        await this.getPDFDelegacionFirma()
      } else {
        await this.getPDFFirmaDelegadaFirmada()
      }
      this.$store.commit('setIsLoading', false)
      console.log(this.pdfVisualicer)
      console.log('Esto es fuera del metodo de recuperar PDF')
      if (this.pdfVisualicer) {
        this.firmaDelegadaDialog = !this.firmaDelegadaDialog
      }
    },
    uploadDialogFirmaDelegada: function () {
      this.uploadState = true
      this.closeDialogFirmaDelegada()
    },
    closeDialogFirmaDelegada () {
      this.firmaDelegadaDialog = !this.firmaDelegadaDialog
    },

    getPDFFirmaDelegadaFirmada: async function () {
      var params = {
        idCIFEmpresa: this.id,
      }
      try {
        const response = await getPDFFirmaDelegadaFirmada(params)
        this.pdfVisualicer = response ? response.data : null
      } catch {
        this.pdfVisualicer = null
        this.doFeedback()
      }
    },

    getPDFDelegacionFirma: async function () {
      const valid = await new Promise((resolve) => {
        this.$refs.ruleFormResponsable.validate((valid) => {
          resolve(valid)
        })
      })
      if (!valid) {
        return
      }
      try {
        const response = await getPdfFirmaDelegada({
          idCIFEmpresa: this.$route.params.id,
          NombreApellidos: this.responsableForm.NombreApellidos,
          NIF: this.responsableForm.NIF,
          Municipio: this.responsableForm.Municipio,
          ViaPublica: this.responsableForm.ViaPublica,
          NumeroViaPublica: this.responsableForm.NumeroViaPublica,
        })
        this.pdfVisualicer = response.data
        console.log(this.pdfVisualicer)
        console.log('Esto es dentro del metodo de recuperar PDF')
      } catch {
        this.doFeedback()
      }
    },

    applylinkCertificateDialog: async function (certificate) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.togglelinkCertificateDialog()
      try {
        const idCIFEmpresa = parseInt(this.$route.params.id)
        const params = {
          idCIFS: [idCIFEmpresa],
          SerialNumber: certificate.SerialNumber,
          TipoCertificado: certificate.TipoCertificado,
          idCliente: certificate.idCliente,
        }
        const response = await linkCertificate(params)
        if (response.blnError === true) {
          this.doFeedback(
            i18n.t('feedback.error.formated_api_response_error', response)
          )
        } else {
          this.doFeedback(
            i18n.t('feedback.success.entity_linked_msg'),
            'success'
          )
          const config = await this.downloadDataConfig(idCIFEmpresa)
          this.setConfig(config)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyFirmaDelegada: function (respuesta) {
      if (respuesta) {
        this.form.CN = ''
        this.form.TipoCertificado = ''
        this.form.FirmaDelegadaActivo = false
        this.hasDocumentFirmaDelegada = true
      }
    },
    goDetailCert: function () {
      const idEmpresa = this.form.clienteId
      const serial = this.form.SerialNumber
      const tipo = this.form.TipoCertificado
      this.$router.push({
        name: 'certificates/detail',
        params: { idCliente: idEmpresa, serial, tipoCertificado: tipo },
      })
    },
    isPasswordValidtc: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validationtc.general = false
        this.validationtc.numChar = false
        this.validationtc.numMin = false
        this.validationtc.charMinus = false
        this.validationtc.charMayus = false
        // return callback(new Error(i18n.t('validation.complete')))
        callback()
      } else {
        if (!re.test(value)) {
          this.validationtc.general = false
        } else {
          this.validationtc.general = true
        }
        if (value.length < 8) {
          this.validationtc.numChar = false
        } else {
          this.validationtc.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validationtc.numMin = false
        } else {
          this.validationtc.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validationtc.charMinus = false
        } else {
          this.validationtc.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validationtc.charMayus = false
        } else {
          this.validationtc.charMayus = true
        }
        if (
          !reMin.test(value) ||
          value.length < 8 ||
          !reNumber.test(value) ||
          !reMinus.test(value) ||
          !reMayus.test(value)
        ) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    isPasswordValidgv: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validationgv.general = false
        this.validationgv.numChar = false
        this.validationgv.numMin = false
        this.validationgv.charMinus = false
        this.validationgv.charMayus = false
        // return callback(new Error(i18n.t('validation.complete')))
        callback()
      } else {
        if (!re.test(value)) {
          this.validationgv.general = false
        } else {
          this.validationgv.general = true
        }
        if (value.length < 8) {
          this.validationgv.numChar = false
        } else {
          this.validationgv.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validationgv.numMin = false
        } else {
          this.validationgv.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validationgv.charMinus = false
        } else {
          this.validationgv.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validationgv.charMayus = false
        } else {
          this.validationgv.charMayus = true
        }
        if (
          !reMin.test(value) ||
          value.length < 8 ||
          !reNumber.test(value) ||
          !reMinus.test(value) ||
          !reMayus.test(value)
        ) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    validateTuComunidadUser: function (rule, value, callback) {
      if (!value && this.form.TuComunidadPassword) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    validateTuComunidadPassword: function (rule, value, callback) {
      if (!value && this.form.TuComunidadUsuario) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    validateGobiernoVascoUser: function (rule, value, callback) {
      if (!value && this.form.GobiernoVascoPassword) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else if (value.length > this.maxLengthCorreos) {
        callback(
          new Error(
            i18n.t('validation.email_length', {
              n_chars: i18n.tc('app.n_character', this.maxLengthCorreos),
            })
          )
        )
      } else {
        callback()
      }
    },
    submitForm: async function (formName) {
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            idCIFEmpresa: this.id,
            FaceEmail: this.form.FaceMailInvoice,
            FaceRecuperarEmail: this.form.FaceRecoverMail,
            TuComunidadUsuario: this.form.TuComunidadUsuario,
            TuComunidadPassword: this.form.TuComunidadPassword,
            FirmarFacturae: this.form.FirmarFacturae,
            FirmarAdjuntosExternos: this.form.FirmarAdjuntos,
            FirmaDelegadaActivo: !this.form.FirmaDelegadaActivo
          }
          const response = await updateConfigCompany(payload)
          if (response && response.blnError === false) {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            if (!this.form.FirmaDelegadaActivo) {
              this.form.CN = ''
              this.form.TipoCertificado = ''
              // this.hasDocumentFirmaDelegada = true
            }
            this.$store.commit('setIsLoading', false)

            if (this.isCompanyCreation) this.goNext()
            else this.goBack()
          } else {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
      this.$store.commit('setIsLoading', false)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$store.commit('app/setFormChanges', false)
      this.$store.dispatch('app/exitMode', 3)
      this.$router.push({ name: 'companies' })
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: companyId }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
        } else {
          // this.setCompany(company.CIFEmpresa, company.TipoServicio)
          return company.CIFEmpresa
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadDataConfig: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: companyId }
        const config = await getConfigCompany(params)
        if (config.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', config))
        } else {
          return config.Configuracion
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setConfig: function (config) {
      if (config) {
        this.idCliente = config.idCliente || null
        this.form.CN = config.CN ? config.CN : null
        this.form.clienteId = config.idCliente ? config.idCliente : null
        this.form.SerialNumber = config.SerialNumber
          ? config.SerialNumber
          : null
        this.form.TipoCertificado = config.TipoCertificado
          ? config.TipoCertificado
          : null

        this.form.FaceMailInvoice = config.FaceEmail ? config.FaceEmail : null
        this.form.FaceRecoverMail = config.FaceRecuperarEmail
          ? config.FaceRecuperarEmail
          : null
        this.form.TuComunidadUsuario = config.TuComunidadUsuario
          ? config.TuComunidadUsuario
          : null
        this.form.TuComunidadPassword = config.TuComunidadPassword
          ? config.TuComunidadPassword
          : null

        this.form.FirmarFacturae = true
        this.form.FirmarAdjuntos = config.FirmarAdjuntosExternos
          ? config.FirmarAdjuntosExternos
          : null
        this.form.FirmaDelegadaActivo = !config.FirmaDelegadaActivo
        this.hasDocumentFirmaDelegada = config.TieneDocumentoFirmaDelegada
      }
    },
    goNext: function () {
      const modules = this.getModulesClient 
      if (modules.length > 0) {
        this.$store.commit('app/setFormChanges', false)
        setTransitionAllowed(3, true)
        if (modules.includes(31) || modules.includes(8)) {
          this.$router.push({ name: 'companies/reportconfig', params: { id: this.id } })
        } else if (modules.includes(12)) {
          this.$router.push({ name: 'companies/pgeconfig', params: { id: this.id } })
        } else if (modules.includes(1)) {
          this.$router.push({ name: 'companies/apsconfig', params: { id: this.id } })
        } else {
          this.goBack()
        }
      } else {
        this.goBack()
      }
    }
  },
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
